export const queryKeys = {
  me: ['me'] as const,
  stats: ['stats'] as const,
  sessions: ['sessions'] as const,
  chatHistory: ['chat-history'] as const,
  trainingProgress: ['training-progress'] as const,
};
